import React from 'react'
import { StyleSheet, css } from 'aphrodite'

// MATERIAL
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

// EXTRA COMPONENTS
import SkewBg from './SkewBg'
import CardAchievement from './Cards/CardAchievement'

// IMAGES
import ImgBa from '../../../assets/Achievements/Ba.png'
import ImgSteam from '../../../assets/Achievements/Steam.png'
import ImgAragon from '../../../assets/Achievements/Aragon.png'
import ImgFSemilla from '../../../assets/Achievements/FSemilla.png'
import imaginelab from '../../../assets/Achievements/imaginelab.png'




export default class Achievements extends React.Component{
    render(){
    return(
        <section id="Achievements" className={css(styles.MainContainer)}>
            <SkewBg />
            <div className="container">
                <section className={css(styles.SecondaryContainer)}>
                    <Typography 
                    variant="display1" 
                    style={{color:'white', marginBottom: 20, fontWeight: 500}}>
                        Achievements
                    </Typography>  
                    <Typography 
                    variant="title" 
                    className={css(styles.subtitle)}
                    style={{}}>
                        Prizes and recognitions we have received
                    </Typography>
                    <Grid  container className="container" justifyContent="space-between" alignItems="center">
                        <Grid style={{margin: '1.2em 1em'}} item md={5}>
                            <CardAchievement
                            title="Incuba Tecnologico" 
                            subtitle="Winner / Top 10 Best Startup"
                            year="2017"
                            buttonText="Read more"
                            image={ImgBa}
                            link="http://www.buenosaires.gob.ar/noticias/incuba-tecnologico-ya-tiene-sus-ganadores"
                            />
                        </Grid>
                        <Grid style={{margin: '1.2em 1em'}} item md={5}>
                            <CardAchievement
                            title="Steam Greenlight" 
                            subtitle="Approved by community"
                            year="2017"
                            buttonText="Read more"
                            image={ImgSteam} 
                            link="https://steamcommunity.com/sharedfiles/filedetails/?id=869396949"
                            />
                        </Grid>
                        <Grid style={{margin: '1.2em 1em'}} item md={5}>
                            <CardAchievement
                            title="EthGlobal Hackathon" 
                            subtitle="Best Aragon Network Project"
                            year="2018"
                            buttonText="Read more"
                            image={ImgAragon}
                            link="https://www.linkedin.com/pulse/argentinean-team-wins-best-aragonnetwork-project-2018-cavazzoli/"
                            />
                        </Grid>
                        <Grid style={{margin: '1.2em 1em'}} item md={5}>
                            <CardAchievement
                            title="Fondo Semilla" 
                            subtitle="Selected for Incubation"
                            year="2018"
                            buttonText="Read more"
                            image={ImgFSemilla}
                            link="https://www.argentina.gob.ar/produccion/fondo-semilla"
                            />
                        </Grid>
                        <Grid style={{margin: '1.2em 1em'}} item md={5}>
                            <CardAchievement
                            title="Imagine Lab" 
                            subtitle="Winner Startup"
                            year="2019"
                            buttonText="Read more"
                            image={imaginelab}
                            link="https://imaginelab.cl/2019/02/22/estas-son-las-startups-pre-seleccionada-por-nuestra-incubadora/"
                            />
                        </Grid>


                    </Grid>
                </section>
            </div>
        </section>
    )
  }
}

const styles = StyleSheet.create({
    MainContainer: {
        position: 'relative',
        minHeight: 1080,
        marginTop: 370,
        '@media (max-width: 768px)': {
            marginTop: 100,  
        }
    },
    SecondaryContainer: {
        paddingTop: '5%',
        color: 'white',
        lineHeight: '1.8em',
        textAlign: 'center',
        '@media (max-width: 768px)': {
            paddingTop: '30%',  
            paddingBottom: '35%',  
        }
    }, 
    container: {
    justifyContent: 'space-between',
    },
    subtitle : {
        color:'white', 
        marginBottom: 80, 
        fontWeight: 400
    }
});


// WEBPACK FOOTER //
// ./src/Components/Home/Achievements/Achievements.js